import { trackerContract } from '@terra/shared-contracts-tracker';
import { createTerraOrpcClient } from '@terra/shared-utils';

const SERVICE_NAME = 'tracker';

export const trackerClient = createTerraOrpcClient({
  contract: trackerContract,
  serviceName: SERVICE_NAME,
});
